module.exports = __webpack_public_path__ + "img/video_play.138a9fae.svg";